import React from "react";
import { useState } from "react";
import { useEffect } from "react";
import { useAppUser } from "../../../../../contexts/user-context/UserContext";
import "./styles.scss";
// import { FiMenu } from "react-icons/fi";

interface User {
  createdAt: Date | undefined;
}

const initUser: User = {
  createdAt: new Date(),
};

const ProfilePageTitle = () => {
  const appUser = useAppUser();
  const [user, setUser] = useState(initUser);

  useEffect(() => {
    if (
      localStorage.getItem("isAuthed") === "true" ||
      sessionStorage.getItem("isAuthed") === "true"
    ) {
      setUser({
        createdAt: appUser.createdAt?.toDate(),
      });
    }
  }, [appUser]);

  return (
    <div className="prfl-page-header-wrapper">
      <div className="blue-line">
        <div className="text-left title">
          <div className="header-text text-truncate">
            {"Profile Information"}
          </div>
        </div>

        <div className="d-flex justify-content-end">
          <div style={{ width: "350px", color: "#fff" }}>
            <div
              style={{ fontSize: "16px", color: "#f9fafc", textAlign: "right" }}
            >
              {"Account Created On : "}
              <span className="ml-1">
                {user.createdAt?.getFullYear() +
                  " " +
                  user.createdAt?.toLocaleString("default", { month: "long" }) +
                  " " +
                  user.createdAt?.getDate()}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProfilePageTitle;
